<template>
    <div>
        <div class="form-group row">
            <label class="col-sm-3 col-xl-2 col-form-label">{{label}}</label>
            <div class="col-sm-9 col-xl-10">
                <input v-if="type === 'text'" class="form-control" :placeholder="placeholder" v-model="filterValue">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    'name': 'DataFilterItem',
    'props': {
        'label': {
            'type': String,
            'default': 'text'
        },
        'type': {
            'type': String,
            'default': ''
        },
        'value': {
            'default': null
        },
        'placeholder': {
            'type': String,
            'default': ''
        },
        'objectKey': {
            'type': String,
            'required': true
        }
    },
    data () {
        return {
            'filterValue': null
        };
    },
    mounted () {
        this.filterValue = this.value;
    },
    'methods': {
        resetSearch () {
            this.filterValue = this.value;
        },
        getValue () {
            return this.filterValue;
        }
    }
};
</script>

<style>

</style>
